var map = {
	"./tds-accordion-item.entry.js": [
		2215,
		2215
	],
	"./tds-accordion.entry.js": [
		432,
		4403
	],
	"./tds-badge.entry.js": [
		950,
		950
	],
	"./tds-banner.entry.js": [
		8623,
		8623
	],
	"./tds-block.entry.js": [
		4484,
		4484
	],
	"./tds-body-cell.entry.js": [
		978,
		978
	],
	"./tds-breadcrumb.entry.js": [
		5428,
		5428
	],
	"./tds-breadcrumbs.entry.js": [
		9127,
		9127
	],
	"./tds-button.entry.js": [
		1045,
		1045
	],
	"./tds-card.entry.js": [
		8479,
		8479
	],
	"./tds-checkbox.entry.js": [
		8532,
		8532
	],
	"./tds-chip.entry.js": [
		5187,
		5187
	],
	"./tds-core-header-item_2.entry.js": [
		2701,
		2701
	],
	"./tds-datetime.entry.js": [
		4576,
		4576
	],
	"./tds-divider.entry.js": [
		2644,
		2644
	],
	"./tds-dropdown-option.entry.js": [
		2956,
		2956
	],
	"./tds-dropdown.entry.js": [
		6520,
		6520
	],
	"./tds-folder-tab.entry.js": [
		3003,
		3003
	],
	"./tds-folder-tabs.entry.js": [
		558,
		558
	],
	"./tds-footer-group.entry.js": [
		1976,
		1976
	],
	"./tds-footer-item.entry.js": [
		180,
		180
	],
	"./tds-footer.entry.js": [
		6350,
		6350
	],
	"./tds-header-brand-symbol.entry.js": [
		2397,
		2397
	],
	"./tds-header-cell.entry.js": [
		4277,
		4277
	],
	"./tds-header-dropdown-list-item.entry.js": [
		313,
		313
	],
	"./tds-header-dropdown-list-user.entry.js": [
		4821,
		4821
	],
	"./tds-header-dropdown-list.entry.js": [
		4505,
		4505
	],
	"./tds-header-dropdown.entry.js": [
		7840,
		7840
	],
	"./tds-header-hamburger.entry.js": [
		1234,
		1234
	],
	"./tds-header-launcher-button.entry.js": [
		7890,
		7890
	],
	"./tds-header-launcher-grid-item.entry.js": [
		3284,
		3284
	],
	"./tds-header-launcher-grid-title.entry.js": [
		9021,
		9021
	],
	"./tds-header-launcher-grid.entry.js": [
		9073,
		1454
	],
	"./tds-header-launcher-list-item.entry.js": [
		2904,
		2904
	],
	"./tds-header-launcher-list-title.entry.js": [
		8385,
		8385
	],
	"./tds-header-launcher-list.entry.js": [
		218,
		218
	],
	"./tds-header-launcher.entry.js": [
		1,
		1
	],
	"./tds-header-title.entry.js": [
		9551,
		9551
	],
	"./tds-header.entry.js": [
		8848,
		8848
	],
	"./tds-icon.entry.js": [
		9012,
		9012
	],
	"./tds-inline-tab.entry.js": [
		5730,
		5730
	],
	"./tds-inline-tabs.entry.js": [
		4341,
		4341
	],
	"./tds-link.entry.js": [
		7897,
		7897
	],
	"./tds-message.entry.js": [
		6378,
		6378
	],
	"./tds-modal.entry.js": [
		6716,
		6716
	],
	"./tds-navigation-tab.entry.js": [
		5061,
		5061
	],
	"./tds-navigation-tabs.entry.js": [
		2848,
		2848
	],
	"./tds-popover-canvas.entry.js": [
		1789,
		1789
	],
	"./tds-popover-core.entry.js": [
		7314,
		7314
	],
	"./tds-popover-menu-item.entry.js": [
		6568,
		6568
	],
	"./tds-popover-menu.entry.js": [
		5466,
		5466
	],
	"./tds-radio-button.entry.js": [
		2571,
		2571
	],
	"./tds-side-menu-close-button.entry.js": [
		790,
		790
	],
	"./tds-side-menu-collapse-button.entry.js": [
		7591,
		7591
	],
	"./tds-side-menu-dropdown-list-item.entry.js": [
		4233,
		4233
	],
	"./tds-side-menu-dropdown-list.entry.js": [
		7193,
		7193
	],
	"./tds-side-menu-dropdown.entry.js": [
		7968,
		7968
	],
	"./tds-side-menu-item.entry.js": [
		5866,
		5866
	],
	"./tds-side-menu-overlay.entry.js": [
		7953,
		7953
	],
	"./tds-side-menu-user-image_2.entry.js": [
		4831,
		4831
	],
	"./tds-side-menu-user.entry.js": [
		3398,
		3398
	],
	"./tds-side-menu.entry.js": [
		8208,
		8208
	],
	"./tds-slider.entry.js": [
		3184,
		3184
	],
	"./tds-spinner.entry.js": [
		3312,
		3312
	],
	"./tds-step.entry.js": [
		8315,
		8315
	],
	"./tds-stepper.entry.js": [
		6916,
		6916
	],
	"./tds-table-body-row-expandable.entry.js": [
		1712,
		1712
	],
	"./tds-table-body-row.entry.js": [
		6439,
		6439
	],
	"./tds-table-body.entry.js": [
		9230,
		9230
	],
	"./tds-table-footer.entry.js": [
		2025,
		2025
	],
	"./tds-table-header.entry.js": [
		4659,
		4659
	],
	"./tds-table-toolbar.entry.js": [
		6611,
		6611
	],
	"./tds-table.entry.js": [
		1717,
		1717
	],
	"./tds-text-field.entry.js": [
		7955,
		7955
	],
	"./tds-textarea.entry.js": [
		1891,
		1891
	],
	"./tds-toast.entry.js": [
		9234,
		9234
	],
	"./tds-toggle.entry.js": [
		269,
		269
	],
	"./tds-tooltip.entry.js": [
		4774,
		4774
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 928;
module.exports = webpackAsyncContext;